import { Directive, ElementRef, forwardRef, HostListener, inject, Renderer2 } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export const YEAR_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => MngYearFieldDirective),
  multi: true
};

@Directive({
  selector: '[mngYearField]',
  providers: [YEAR_VALUE_ACCESSOR]
})
export class MngYearFieldDirective implements ControlValueAccessor {
  private renderer = inject(Renderer2);
  private elementRef = inject(ElementRef);

  @HostListener('change', ['$event.target.value']) onChange: (value: string) => void;

  @HostListener('input', ['$event.target.value']) onInput: (value: string) => void;

  @HostListener('focus', []) onTouched = () => {
    return;
  };

  /**
   * Wert --> HTML Element
   */
  writeValue(isoDate: string) {
    // MODEL -> VIEW
    if (isoDate && isoDate.length === 10) {
      const viewValue = isoDate.substr(0, 4);
      this.renderer.setProperty(this.elementRef.nativeElement, 'value', viewValue);
    } else {
      this.renderer.setProperty(this.elementRef.nativeElement, 'value', '');
    }
  }

  registerOnChange(fn: (_: any) => void) {
    // VIEW -> MODEL
    this.onChange = (year) => {
      const isoDate = year.length === 4 ? year + '-01-01' : '';
      fn(isoDate);
    };
    this.onInput = this.onChange;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.renderer.setProperty(this.elementRef.nativeElement, 'disabled', isDisabled);
  }
}
